import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppChat = () => {
  const phoneNumber = '14377846664';
  const message = "Hello, I'm interested in enrolling at Fast Track College. Could you share the admission requirements?";
  
  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={handleClick} title="Chat with us on WhatsApp">
      <FaWhatsapp />
    </div>
  );
};

export default WhatsAppChat;
